import _ from 'lodash';
import { getText } from 'common/utils/dictionary';
import {
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	UNIFORM_PROPS,
} from 'common/constants';
import View from 'client/components/common/BuildingBlocks/Text/Text';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const TEXT = (options = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.TEXT;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: TEXT.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, TEXT.displayName),
					},
					componentProps: {
						styles: {},
						other: {},
						[UNIFORM_PROPS.tag]: 'p',
					},
				},
				children: {
					[COMPONENT_STATES.DEFAULT]: {
						[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: getText(
							// @ts-expect-error ts-migrate FIXME
							options.dictionary,
							type,
							`text_${_.random(2)}`
						),
					},
				},
			};
		},
	};
};

TEXT.displayName = 'Text';
